import { render, staticRenderFns } from "./DisplayLesson.vue?vue&type=template&id=fda466e6&"
import script from "./DisplayLesson.vue?vue&type=script&lang=js&"
export * from "./DisplayLesson.vue?vue&type=script&lang=js&"
import style0 from "./DisplayLesson.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports